import "../../../src/components/VList/VListItemGroup.sass";
import { BaseItemGroup } from '../VItemGroup/VItemGroup';
import Colorable from '../../mixins/colorable';
import mixins from '../../util/mixins';
export default mixins(BaseItemGroup, Colorable).extend({
    name: 'v-list-item-group',
    provide() {
        return {
            isInGroup: true,
            listItemGroup: this
        };
    },
    computed: {
        classes() {
            return { ...BaseItemGroup.options.computed.classes.call(this),
                'v-list-item-group': true
            };
        }
    },
    methods: {
        genData() {
            return this.setTextColor(this.color, { ...BaseItemGroup.options.methods.genData.call(this),
                attrs: {
                    role: 'listbox'
                }
            });
        }
    }
});
